import {
  actorTypes, authenticationTypes, canUpload, isTransactionAllowed, transactions,
} from 'dmpconnectjsapp-base/rules/accessRights';
import { documentStatuses, documentVisibilityStatuses, isHiddenFor } from 'dmpconnectjsapp-base/helpers/findDocuments';

const uniqueUUidSeparator = '__';

export const calculateVisibility = (patientHidden, healthcareProfessionalHidden, guardianHidden, forUpload = false) => {
  const patientHiddenBool                = [true, '1', 1].includes(patientHidden);
  const healthcareProfessionalHiddenBool = [true, '1', 1].includes(healthcareProfessionalHidden);
  const guardianHiddenBool               = [true, '1', 1].includes(guardianHidden);
  
  if (!patientHiddenBool && !healthcareProfessionalHiddenBool && !guardianHiddenBool) {
    return forUpload ? documentVisibilityStatuses.NORMAL : null;
  }
  return (patientHiddenBool ? documentVisibilityStatuses.PATIENT_HIDDEN : 0)
         + (healthcareProfessionalHiddenBool ? documentVisibilityStatuses.HEALTCARE_PROFESSIONAL_HIDDEN : 0)
         + (guardianHiddenBool ? documentVisibilityStatuses.GUARDIAN_HIDDEN : 0);
};

/**
 * Test if ps owns the document
 * @param document
 * @param psId
 * @returns {*}
 */
// export const ownsDocument = (document, psId) => document.Authors && document.Authors.some(item => item.s_hpInternalId === psId);
export const ownsDocument = (document, accessRights) => document.Authors && document.Authors.some((item) => {
  const internalId = item.s_hpInternalId;
  
  const { psId, authenticationType, esId } = accessRights;
  
  // si AIR, on match l'établissement et l'auteur
  if (authenticationType === authenticationTypes.AIR && internalId.indexOf('/') > -1) {
    const [structId, userId] = internalId.split('/');
    const [,finess] = esId.split('_');
    return psId === userId && finess.substring(1) === structId.substring(1);
  }

  return item.s_hpInternalId === psId;
});
export const getUniqueUUid = (uniqueId, uuid) => `${uniqueId}${uniqueUUidSeparator}${uuid}`;
export const explodeUniqueUUid = (uniqueUUid) => {
  const [uniqueId, uuid] = uniqueUUid.split(uniqueUUidSeparator);
  return { uniqueId, uuid };
};

export const canEditDocument = (document, accessRights, userDoc, secret) => {
  return (
    ownsDocument(document, accessRights)
    && canUpload(accessRights)
    && document.i_document_Status !== documentStatuses.ARCHIVED
    && document.i_document_Status !== documentStatuses.DEPRECATED
    && (
      !userDoc.i_forceConfidentiality
      || (
        userDoc.i_forceConfidentiality === 1
        && isHiddenFor(document.i_document_Visibility || document.i_documentVisibility, documentVisibilityStatuses.GUARDIAN_HIDDEN)
      )
    )
    && (
      !secret
      || (
        secret
        && isHiddenFor(document.i_document_Visibility || document.i_documentVisibility, documentVisibilityStatuses.GUARDIAN_HIDDEN)
      )
    )
  );
};

export const canEditDocumentStatus = (document, accessRights) => (
  document.i_document_Status !== documentStatuses.DEPRECATED
  && (
    isTransactionAllowed(accessRights, transactions.ARCHIVE_DOC) === true
    || isTransactionAllowed(accessRights, transactions.UNARCHIVE_DOC) === true
  )
  && (
    accessRights.actorType !== actorTypes.PS_NO_PHYSICIAN
    || ownsDocument(document, accessRights)
  )
);

export const canEditDocumentVisibility = (document, accessRights, userDoc, secret) => (
  document.i_document_Status !== documentStatuses.ARCHIVED
  && document.i_document_Status !== documentStatuses.DEPRECATED
  && (
    isTransactionAllowed(accessRights, transactions.HIDE_DOC_TO_PS) === true
    || isTransactionAllowed(accessRights, transactions.UNHIDE_DOC_TO_PS) === true
    || isTransactionAllowed(accessRights, transactions.UNHIDE_DOC_TO_PATIENT) === true
  )
  && (
    !userDoc.i_forceConfidentiality
    || (
      userDoc.i_forceConfidentiality === 1
      && isHiddenFor(document.i_document_Visibility || document.i_documentVisibility, documentVisibilityStatuses.GUARDIAN_HIDDEN)
    )
  )
  && (
    !secret
    || (
      secret
      && isHiddenFor(document.i_document_Visibility || document.i_documentVisibility, documentVisibilityStatuses.GUARDIAN_HIDDEN)
    )
  )
);

export const canDeleteDocument = (document, accessRights) => ownsDocument(document,
  accessRights)
  && document.i_document_Status !== documentStatuses.ARCHIVED
  && document.i_document_Status !== documentStatuses.DEPRECATED
  && isTransactionAllowed(accessRights, transactions.DELETE_DOC) === true;

// export const canConsultDocumentBack = (document, accessRights) => (
//   (
//     isTransactionAllowed(accessRights, transactions.CONSULT_DOCUMENT_HPS) === true
//       && (
//         !isHiddenFor(document.i_document_Visibility,
//           documentVisibilityStatuses.HEALTCARE_PROFESSIONAL_HIDDEN)
//         || ownsDocument(document, accessRights)
//       )
//   )
//     || isTransactionAllowed(accessRights, transactions.CONSULT_DOCUMENT_NHPS) === true
// );

export const canConsultDocument = (document, accessRights) => {
  const hidden = isHiddenFor(document.i_document_Visibility, documentVisibilityStatuses.HEALTCARE_PROFESSIONAL_HIDDEN);
  
  return (
    (
      // fichier caché, mais propriétaire du document ou MT
      hidden
      && (
        (
          ownsDocument(document, accessRights)
          || accessRights.treatingPhysician === true
        )
        // && isTransactionAllowed(accessRights, transactions.CONSULT_DOCUMENT_HPS) === true
      )
    )
    || (
      !hidden
      // && isTransactionAllowed(accessRights, transactions.CONSULT_DOCUMENT_NHPS) === true
    )
  );
};
